import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  OnDestroy,
  ViewChild,
  EventEmitter,
  Output,
} from "@angular/core";
import { DatePipe } from "@angular/common";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Configuration, ConsumerPanelDatasource } from "@/shared-module/models";

@Component({
  selector: "app-customerpaneldialog",
  templateUrl: "customerpaneldialog.component.html",
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .validate-lb .modal-full .modal-body {
        color: #00001f;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 80%;
      }
      .validate-lb .modal-full .h2-eq {
        margin-bottom: 32px;
      }
      .btn-validate {
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 2px;
        padding: 12px 24px;
        background-color: #2d81ff;
        color: #ffffff;
        border-radius: 24px;
        margin-top: 16px;
        margin-right: 16px;
      }
      .btn-validate:disabled {
        background-color: #c9c9db;
      }
      .btn-validate {
        background-color: #ffffff;
        color: #00001f;
        border: 1px solid #c9c9db;
      }
    `,
  ],
})
export class CustomerPanelDialogComponent implements OnInit, OnDestroy {
  @ViewChild("template", { static: true }) template;
  @ViewChild("content", { static: true }) content;
  @Input() data: ConsumerPanelDatasource;
  @Output() onpanelsubmit: EventEmitter<ConsumerPanelDatasource> =
    new EventEmitter();
  @Input() texts: any;
  subs = new SubSink();
  cssColor: string;
  rgbColor: string;
  modalReference: any;

  constructor(
    private configurationService: ConfigurationService,
    private modalService: NgbModal,
    public datepipe: DatePipe,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
        thisObject.rgbColor = c.rgb;
      },
    );
  }

  getFormattedText() {
    return this.texts?.introDone.replace(
      "<! date !>",
      this.datepipe.transform(this.data?.submittedOn, "dd/MM/y HH:mm"),
    );
  }

  ngOnInit() {}

  confirm(): void {
    this.onpanelsubmit.emit(this.data);
  }

  open() {
    this.modalReference = this.modalService.open(this.content, {
      ariaLabelledBy: "modal-basic-title",
      windowClass: "modal-full modal-dialog-scrollable",
      size: "xl",
      backdrop: "static",
      keyboard: false,
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
